// src/modules/restaurant/pages/respayment/components/OrderSummaryCard.tsx
import React from "react";
import { Divider } from "@mui/material";
import ReceiptIcon from "@mui/icons-material/Receipt";
import { OrderList } from "src/business-types/restaurant/modules/orders/types/orderTypes";
import { useFormatAmount } from "src/business-types/laundry/modules/home/hooks/useFormatAmount";
import { useUser } from "src/business-types/grocery/components/UserContext";

interface Props {
  order: OrderList | null;
  tip: number;
  total: number;
  themeTextColor: string;
  getLightBgClass: () => string;
}

const OrderSummaryCard: React.FC<Props> = ({ order, tip, total, themeTextColor, getLightBgClass }) => {
  const formatAmount = useFormatAmount();
  const { userConfigration } = useUser();
    const toBoolean = (value: any) =>value === true || value === "true";
    const deliveryFeeEnabled = toBoolean(userConfigration?.deliveryFeeEnabled);
  return (
  <div className="mb-2">
    <div className="flex items-center gap-2 -mb-2 -mt-2.5">
      <div className={`p-1 ${getLightBgClass()} rounded-lg`}>
        <ReceiptIcon className={`${themeTextColor} text-lg`} />
      </div>
      <h3 className="font-bold py-2 text-gray-800 text-lg">Order Summary</h3>
    </div>

    <div className=" bg-gradient-to-br from-gray-50 to-blue-50 rounded-xl p-2 border border-gray-200">
      {[
        { label: "Subtotal", value: formatAmount(order?.totalAmount || 0), color: "blue" },
        ...(deliveryFeeEnabled
    ? [
        {
          label: "Delivery Fee",
          value: formatAmount(order?.deliveryFee || 0)
        },
      ]
    : []),
        { label: "Discount", value: formatAmount(order?.discount || 0), color: "red" },
        { label: "Tip", value: formatAmount(tip), color: "green" },
      ].map(({ label, value, color }) => (
        <div key={label} className="flex justify-between items-center py-0.5">
          <span className="text-gray-600 flex items-center gap-2 font-medium text-sm">
            <div className={`w-2 h-2 ${
              color === "green" ? "bg-green-500" : color === "red" ? "bg-red-500" : themeTextColor.replace("text-", "bg-")
            } rounded-full`}></div>
            {label}
          </span>
          <span className={`font-semibold text-base ${
            color === "green" ? "text-green-600" : color === "red" ? "text-red-500" : "text-gray-700"
          }`}>{value}</span>
        </div>
      ))}

      <Divider className="my-1.5 border-gray-300" />

      <div className="flex justify-between items-center pt-0.5">
        <span className="text-lg font-bold text-gray-900">TOTAL</span>
        <span className={`text-xl font-bold bg-gradient-to-r text-black to-purple-600`}>
          {total.toFixed(2)}
        </span>
      </div>
    </div>
  </div>
  );
};

export default OrderSummaryCard;
